var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Table",
        {
          staticClass: "panorama-summary-table",
          staticStyle: { "margin-top": "1rem" }
        },
        [
          _c(
            "TableHeader",
            [
              _c(
                "TableRow",
                _vm._l(_vm.panoramaSummaryColumns, function(
                  panoramaSummaryCol,
                  index
                ) {
                  return _c(
                    "TableHead",
                    {
                      key: `${panoramaSummaryCol.label}_${index}`,
                      class: panoramaSummaryCol.class,
                      attrs: { colspan: panoramaSummaryCol.colspan }
                    },
                    [
                      _c(
                        "span",
                        { style: panoramaSummaryCol.style },
                        [
                          _vm._v(
                            _vm._s(panoramaSummaryCol.label) + "\n            "
                          ),
                          panoramaSummaryCol.label === "Status Fatura"
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-secondary"
                                  },
                                  on: {
                                    click: () =>
                                      _vm.toggleAllGroupsAndSubgroups()
                                  }
                                },
                                [
                                  _vm.toggleGroups.length === 0
                                    ? _c("span", [_vm._v("Desagrupar")])
                                    : _c("span", [_vm._v("Agrupar")])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.panoramaStatusSummaryList, function(
            panoramaGroup,
            panoramaGroupIndex
          ) {
            return _c(
              "TableBody",
              { key: `${panoramaGroup.name}_${panoramaGroupIndex}` },
              [
                _c(
                  "TableRow",
                  { staticClass: "group-row" },
                  [
                    _c(
                      "TableCell",
                      {
                        staticClass:
                          "panorama-summary-table-cell pinned lv0 divider",
                        style: _vm.setInvoiceSummaryStatusColor(
                          panoramaGroup.name
                        ),
                        attrs: { colspan: "3" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "status",
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.translatePanoramaSummaryStatusName(
                                    panoramaGroup.name
                                  )
                                ) +
                                "\n            "
                            ),
                            (panoramaGroup.subGroups.length > 0 ||
                              panoramaGroup.status.length > 0) &&
                            !_vm.toggleGroups.includes(panoramaGroup.name)
                              ? _c("b-icon-chevron-down", {
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleGroup(panoramaGroup.name)
                                    }
                                  }
                                })
                              : panoramaGroup.subGroups.length > 0 ||
                                panoramaGroup.status.length > 0
                              ? _c("b-icon-chevron-up", {
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleGroup(panoramaGroup.name)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "TableCell",
                      {
                        staticClass:
                          "panorama-summary-table-cell divider pinned lv3",
                        staticStyle: { "text-align": "right" }
                      },
                      [
                        _c("RenderPanoramaSummaryInvoiceLine", {
                          attrs: {
                            "invoice-value": panoramaGroup.total,
                            "qty-invoices": panoramaGroup.qtyInvoices,
                            "overall-percentage-invoice-value":
                              panoramaGroup.percentageOfTotalOverall,
                            status: panoramaGroup.name,
                            "show-invoice-value":
                              _vm.selectedFields.invoiceValue,
                            "show-qty-invoice": _vm.selectedFields.qtyInvoices,
                            "show-overall-percentage":
                              _vm.selectedFields.overallPercentage,
                            "show-sub-total-percentage":
                              _vm.selectedFields.subTotalPercentage,
                            "show-average-ticket":
                              _vm.selectedFields.averageTicket
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(Array.from(panoramaGroup.invoicesData), function(
                      [key, invoiceData],
                      index
                    ) {
                      return [
                        _c(
                          "TableCell",
                          {
                            staticClass: "panorama-summary-table-cell divider",
                            staticStyle: { "text-align": "right" }
                          },
                          [
                            _c("RenderPanoramaSummaryInvoiceLine", {
                              attrs: {
                                "invoice-value": invoiceData.total || 0,
                                "qty-invoices": invoiceData.qtyInvoices || 0,
                                "overall-percentage-invoice-value":
                                  invoiceData.percentageOfTotalOverall || 0,
                                "sub-total-percentage-invoice-value":
                                  invoiceData.percentageOfSubTotal || 0,
                                status: panoramaGroup.name,
                                "show-invoice-value":
                                  _vm.selectedFields.invoiceValue,
                                "show-qty-invoice":
                                  _vm.selectedFields.qtyInvoices,
                                "show-overall-percentage":
                                  _vm.selectedFields.overallPercentage,
                                "show-sub-total-percentage":
                                  _vm.selectedFields.subTotalPercentage,
                                "show-average-ticket":
                                  _vm.selectedFields.averageTicket
                              }
                            })
                          ],
                          1
                        )
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(panoramaGroup.status, function(panoramaStatus, index) {
                  return _vm.toggleGroups.includes(panoramaGroup.name)
                    ? _c(
                        "TableRow",
                        {
                          key: `${panoramaStatus.name}_${index}`,
                          staticClass: "status-row"
                        },
                        [
                          _c("TableCell", { staticClass: "pinned lv0" }, [
                            _c("div", { staticClass: "empty-cell" })
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass:
                                "panorama-summary-table-cell pinned lv1 divider",
                              style: _vm.setInvoiceSummaryStatusColor(
                                panoramaStatus.name
                              ),
                              attrs: { colspan: "2" }
                            },
                            [
                              _c("div", { staticClass: "status" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.translatePanoramaSummaryStatusName(
                                        panoramaStatus.name
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass:
                                "panorama-summary-table-cell divider pinned lv3",
                              staticStyle: { "text-align": "right" }
                            },
                            [
                              _c("RenderPanoramaSummaryInvoiceLine", {
                                attrs: {
                                  "invoice-value": panoramaStatus.total,
                                  "qty-invoices": panoramaStatus.qtyInvoices,
                                  "overall-percentage-invoice-value":
                                    panoramaStatus.percentageOfTotalOverall,
                                  status: panoramaStatus.name,
                                  "show-invoice-value":
                                    _vm.selectedFields.invoiceValue,
                                  "show-qty-invoice":
                                    _vm.selectedFields.qtyInvoices,
                                  "show-overall-percentage":
                                    _vm.selectedFields.overallPercentage,
                                  "show-sub-total-percentage":
                                    _vm.selectedFields.subTotalPercentage,
                                  "show-average-ticket":
                                    _vm.selectedFields.averageTicket
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(
                            Array.from(panoramaStatus.invoicesData),
                            function([key, invoiceData], index) {
                              return [
                                _c(
                                  "TableCell",
                                  {
                                    staticClass:
                                      "panorama-summary-table-cell divider",
                                    staticStyle: { "text-align": "right" }
                                  },
                                  [
                                    _c("RenderPanoramaSummaryInvoiceLine", {
                                      attrs: {
                                        "invoice-value": invoiceData.total || 0,
                                        "qty-invoices":
                                          invoiceData.qtyInvoices || 0,
                                        "overall-percentage-invoice-value":
                                          invoiceData.percentageOfTotalOverall ||
                                          0,
                                        "sub-total-percentage-invoice-value":
                                          invoiceData.percentageOfSubTotal || 0,
                                        status: panoramaStatus.name,
                                        "show-invoice-value":
                                          _vm.selectedFields.invoiceValue,
                                        "show-qty-invoice":
                                          _vm.selectedFields.qtyInvoices,
                                        "show-overall-percentage":
                                          _vm.selectedFields.overallPercentage,
                                        "show-sub-total-percentage":
                                          _vm.selectedFields.subTotalPercentage,
                                        "show-average-ticket":
                                          _vm.selectedFields.averageTicket
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          )
                        ],
                        2
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(panoramaGroup.subGroups, function(
                  panoramaSubGroup,
                  panoramaSubgroupIndex
                ) {
                  return _vm.toggleGroups.includes(panoramaGroup.name)
                    ? [
                        _c(
                          "TableRow",
                          { staticClass: "subgroup-row" },
                          [
                            _c("TableCell", { staticClass: "pinned lv0" }, [
                              _c("div", { staticClass: "empty-cell" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "TableCell",
                              {
                                staticClass:
                                  "panorama-summary-table-cell pinned lv1 divider",
                                style: _vm.setInvoiceSummaryStatusColor(
                                  panoramaSubGroup.name
                                ),
                                attrs: { colspan: "2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "status",
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.translatePanoramaSummaryStatusName(
                                            panoramaSubGroup.name
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                    !_vm.toggleSubgroups.includes(
                                      panoramaSubGroup.name
                                    )
                                      ? _c("b-icon-chevron-down", {
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleSubgroup(
                                                panoramaSubGroup.name
                                              )
                                            }
                                          }
                                        })
                                      : _c("b-icon-chevron-up", {
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleSubgroup(
                                                panoramaSubGroup.name
                                              )
                                            }
                                          }
                                        })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "TableCell",
                              {
                                staticClass:
                                  "panorama-summary-table-cell divider pinned lv3",
                                staticStyle: { "text-align": "right" }
                              },
                              [
                                _c("RenderPanoramaSummaryInvoiceLine", {
                                  attrs: {
                                    "invoice-value": panoramaSubGroup.total,
                                    "qty-invoices":
                                      panoramaSubGroup.qtyInvoices,
                                    "overall-percentage-invoice-value":
                                      panoramaSubGroup.percentageOfTotalOverall,
                                    status: panoramaSubGroup.name,
                                    "show-invoice-value":
                                      _vm.selectedFields.invoiceValue,
                                    "show-qty-invoice":
                                      _vm.selectedFields.qtyInvoices,
                                    "show-overall-percentage":
                                      _vm.selectedFields.overallPercentage,
                                    "show-sub-total-percentage":
                                      _vm.selectedFields.subTotalPercentage,
                                    "show-average-ticket":
                                      _vm.selectedFields.averageTicket
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              Array.from(panoramaSubGroup.invoicesData),
                              function([key, invoiceData], index) {
                                return [
                                  _c(
                                    "TableCell",
                                    {
                                      staticClass:
                                        "panorama-summary-table-cell divider",
                                      staticStyle: { "text-align": "right" }
                                    },
                                    [
                                      _c("RenderPanoramaSummaryInvoiceLine", {
                                        attrs: {
                                          "invoice-value":
                                            invoiceData.total || 0,
                                          "qty-invoices":
                                            invoiceData.qtyInvoices || 0,
                                          "overall-percentage-invoice-value":
                                            invoiceData.percentageOfTotalOverall ||
                                            0,
                                          "sub-total-percentage-invoice-value":
                                            invoiceData.percentageOfSubTotal ||
                                            0,
                                          status: panoramaSubGroup.name,
                                          "show-invoice-value":
                                            _vm.selectedFields.invoiceValue,
                                          "show-qty-invoice":
                                            _vm.selectedFields.qtyInvoices,
                                          "show-overall-percentage":
                                            _vm.selectedFields
                                              .overallPercentage,
                                          "show-sub-total-percentage":
                                            _vm.selectedFields
                                              .subTotalPercentage,
                                          "show-average-ticket":
                                            _vm.selectedFields.averageTicket
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l(panoramaSubGroup.status, function(
                          panoramaStatus,
                          index
                        ) {
                          return _vm.toggleGroups.includes(
                            panoramaGroup.name
                          ) &&
                            _vm.toggleSubgroups.includes(panoramaSubGroup.name)
                            ? _c(
                                "TableRow",
                                {
                                  key: `${panoramaStatus.name}_${index}`,
                                  staticClass: "status-row"
                                },
                                [
                                  _c(
                                    "TableCell",
                                    { staticClass: "pinned lv0" },
                                    [_c("div", { staticClass: "empty-cell" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "TableCell",
                                    { staticClass: "pinned lv1" },
                                    [_c("div", { staticClass: "empty-cell" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "TableCell",
                                    {
                                      staticClass:
                                        "panorama-summary-table-cell pinned lv2 divider",
                                      style: _vm.setInvoiceSummaryStatusColor(
                                        panoramaStatus.name
                                      )
                                    },
                                    [
                                      _c("div", { staticClass: "status" }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.translatePanoramaSummaryStatusName(
                                                panoramaStatus.name
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "TableCell",
                                    {
                                      staticClass:
                                        "panorama-summary-table-cell divider pinned lv3",
                                      staticStyle: { "text-align": "right" }
                                    },
                                    [
                                      _c("RenderPanoramaSummaryInvoiceLine", {
                                        attrs: {
                                          "invoice-value": panoramaStatus.total,
                                          "qty-invoices":
                                            panoramaStatus.qtyInvoices,
                                          "overall-percentage-invoice-value":
                                            panoramaStatus.percentageOfTotalOverall,
                                          status: panoramaStatus.name,
                                          "show-invoice-value":
                                            _vm.selectedFields.invoiceValue,
                                          "show-qty-invoice":
                                            _vm.selectedFields.qtyInvoices,
                                          "show-overall-percentage":
                                            _vm.selectedFields
                                              .overallPercentage,
                                          "show-sub-total-percentage":
                                            _vm.selectedFields
                                              .subTotalPercentage,
                                          "show-average-ticket":
                                            _vm.selectedFields.averageTicket
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    Array.from(panoramaStatus.invoicesData),
                                    function([key, invoiceData], index) {
                                      return [
                                        _c(
                                          "TableCell",
                                          {
                                            staticClass:
                                              "panorama-summary-table-cell divider",
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c(
                                              "RenderPanoramaSummaryInvoiceLine",
                                              {
                                                attrs: {
                                                  "invoice-value":
                                                    invoiceData.total || 0,
                                                  "qty-invoices":
                                                    invoiceData.qtyInvoices ||
                                                    0,
                                                  "overall-percentage-invoice-value":
                                                    invoiceData.percentageOfTotalOverall ||
                                                    0,
                                                  "sub-total-percentage-invoice-value":
                                                    invoiceData.percentageOfSubTotal ||
                                                    0,
                                                  status: panoramaStatus.name,
                                                  "show-invoice-value":
                                                    _vm.selectedFields
                                                      .invoiceValue,
                                                  "show-qty-invoice":
                                                    _vm.selectedFields
                                                      .qtyInvoices,
                                                  "show-overall-percentage":
                                                    _vm.selectedFields
                                                      .overallPercentage,
                                                  "show-sub-total-percentage":
                                                    _vm.selectedFields
                                                      .subTotalPercentage,
                                                  "show-average-ticket":
                                                    _vm.selectedFields
                                                      .averageTicket
                                                }
                                              }
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        })
                      ]
                    : _vm._e()
                })
              ],
              2
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }